// import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import SpecialOffer from './SpecialOffer.component';
import {connect} from "react-redux";
export const ProductListDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/ProductList/ProductList.dispatcher'
);


/** @namespace Component/SpecialOffer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    pages: state.ProductListReducer.pages,
    device: state.ConfigReducer.device
});

/** @namespace Component/SpecialOffer/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    requestProductList: (options) => ProductListDispatcher.then(
        ({ default: dispatcher }) => dispatcher.handleData(dispatch, options)
    ),
});

/** @namespace Component/SpecialOffer/Container */
class SpecialOfferContainer extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    containerFunctions = {
    };

    componentDidMount() {
        const { requestProductList, post : { list_type } } = this.props;
        if(list_type){
            const options = {
                args: {
                    filter : this._getFilter(),
                    pageSize : 12,
                    currentPage : 1,
                }
            };
            requestProductList(options);
        }
    }

    _getFilter() {
        const { post : { productlist_id } } = this.props;
        let filters = {
            customFilters : {  mg_custom_lists : [productlist_id] }
        };
        return filters;
    }

    containerProps = () => {
        return {
            ...this.props
        };
    };

    render() {
        return (
            <SpecialOffer
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOfferContainer);
